import { Pressable } from "@/components/ui/pressable";
import { Image } from "@/components/ui/image";
import { VStack } from "@/components/ui/vstack";
import { View } from "@/components/ui/view";
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import * as FileSystem from 'expo-file-system';
import i18n from '../../assets/i18n';
import { FlatList } from 'react-native-gesture-handler';
import * as MediaSelector from './MediaSelector'
import Media from './Media';
import BasicButton from "../basic/BasicButton";
import { WebView } from 'react-native-webview';

const collectMedia = (workflow, avatar) => {
  let media = [...workflow.media]
  if (typeof avatar == 'string' && !media.includes(avatar)) {
    media.push(avatar)
  }
  workflow.steps.forEach(step => {
    media = media.concat(step.media)
    if (step.check) {
      step.check.forEach(item => {
        media = media.concat(item.media)
      })
    }
  })
  return media
}

const selectImage = async (imgFile) => {
  console.log('IMG', imgFile)
  const fileInfo = await FileSystem.getInfoAsync(imgFile)
  console.log('INFO', fileInfo)
  if (fileInfo.size < 100) {
    FileSystem.readAsStringAsync(imgFile).then(data => alert(data))
  } else {
    alert(imgFile.replace(/.*\//, '') + ' size=' + fileInfo.size)
  }
  // FileSystem.deleteAsync(imgFile)
  // setData(data.filter(file => file != imgFile))
}

function MediaButton({ uri, unused, usage ,size, deleteSelectedImage }) {
  return (
    <Pressable onPress={() => selectImage(uri)} onLongPress={() => deleteSelectedImage(uri)}>
      {uri.endsWith('.pdf') ? <WebView originWhitelist={['*']} javaScriptEnabled={true} domStorageEnabled={true} style={{ flex: 1, marginTop: 20 }} source={{ uri: uri }} /> : <Media icon={unused ? 'delete' :  usage != 'WORKFLOW' ? 'face' : MediaSelector.isVideo(uri) ? 'videocam' : ''} uri={uri} size={size} active={false} refresh={Date.now()} />}
    </Pressable>
  );
}

export default function MediaManager({ navigation }) {
  const [image, setImage] = useState(null)
  const [data, setData] = useState([])
  const [sizeMB, setSizeMB] = useState(0)
  const [usage, setUsage] = useState({})
  const [unused, setUnused] = useState([])
  const [actDir, setActDir] = useState(MediaSelector.inaDir)

  const user = useSelector((state) => state.user)
  const workflows = useSelector((state) => state.workflows)
  const contacts = useSelector((state) => state.contacts)
  const imageCrop = useSelector((state) => state.settings.imageCrop)

  // component mounted
  useEffect(() => {
    MediaSelector.requestPermissions()
    MediaSelector.ensureDirExists()
    navigation.setOptions({ title: 'Media Manager' })
  }, [])

  const takePhoto = () => {
    MediaSelector.takePhoto(imageCrop, setImage)
  }

  const pickImage = () => {
    MediaSelector.pickImage(i18n.t('mediaManager.imageLoadTitle'), imageCrop, setImage)
  }

  const showImages = () => {
    navigation.setOptions({ info: i18n.t('mediaManager.savedImages') })
    listDir(MediaSelector.inaDir, "SAVED")
  }

  const showCache = () => {
    navigation.setOptions({ info: i18n.t('mediaManager.cachedImages') })
    listDir(FileSystem.cacheDirectory + 'ImagePicker/', "CACHED")
  }

  const showPrint = () => {
    navigation.setOptions({ info: i18n.t('mediaManager.printedPDFs') })
    listDir(FileSystem.cacheDirectory + 'Print/', "PRINTED")
  }

  const deleteUnusedImages = () => {
    if (unused.length > 0) {
      unused.forEach(deleteImage => {
        console.log('Delete', deleteImage)
        FileSystem.deleteAsync(actDir + deleteImage)
      })
      setData(data.filter(x => !unused.includes(x)))
      setUnused([])
    }
  }

  const deleteAllImages = () => {
    data.forEach(deleteImage => {
      console.log('Delete', deleteImage)
      FileSystem.deleteAsync(actDir + deleteImage)
    })
    setData([])
  }

  const deleteSelectedImage = async (imgFile) => {
    console.log('DELIMG', imgFile)
    FileSystem.deleteAsync(imgFile)
    setData(data.filter(file => file != imgFile))
  }

  const listDir = async (dir, info) => {
    setActDir(dir)
    let usedMedia = []
    let usageType = {}
    contacts.active.forEach(contact => {
      if (!usedMedia.includes(contact.id)) {
        usedMedia.push(contact.id)
        usageType[contact.id] = 'CONTACT'
      }
      if (!usedMedia.includes(contact.toUser.id)) {
        usedMedia.push(contact.toUser.id)
        usageType[contact.toUser.id] = 'AVATAR'
      }
    })
    contacts.channels.forEach(channel => {
      if (channel?.channelImage?.id && !usedMedia.includes(channel.channelImage.id)) {
        usedMedia.push(channel.channelImage.id)
        usageType[channel.channelImage.id] = 'CHANNEL'
      }
    })
    for (let wId in workflows) {
      if (wId.length > 2) {
        const medias = collectMedia(workflows[wId], workflows[wId].contact || user.avatar);
        medias.forEach(mediaId => {
          if (!usedMedia.includes(mediaId)) {
            usedMedia.push(mediaId)
            usageType[mediaId] = 'WORKFLOW'
          }
        })
        usageType[workflows[wId].contact || user.avatar] = 'OWNER'
      }
    }
    if (typeof user.avatar != 'number') {
      usedMedia.push(user.avatar)
      usageType[user.avatar] = 'USER'
    }

    const dirInfo = await FileSystem.getInfoAsync(dir)
    if (dirInfo.exists) {
      const files = await FileSystem.readDirectoryAsync(dir)
      const notUsed = files.filter(x => !usedMedia.includes(x.replace(/\.png$/, '')))
      setUnused(notUsed)
      setUsage(usageType)
      setData(notUsed.concat(files.filter(file => !notUsed.includes(file))))
      console.log('UNUSED', notUsed)
      Promise.all(files.map(file => fileDetails(dir, file))).then(results => {
        const size = Math.ceil(results.reduce((sum, info) => sum + info.size, 0) * 100 / 1024 / 1024) / 100
        setSizeMB(size)
        console.log(info, results.length, size + 'MB')
      })
      // console.log('FILES', JSON.stringify(files))
    } else {
      console.log("Directory '" + dir + "' doesn't exist.")
    }
  }

  const fileDetails = async (dir, file) => {
    const fileInfo = await FileSystem.getInfoAsync(dir + file)
    const info = { file: file, size: fileInfo.size }
    // console.log('INFO', fileInfo)
    return info
  }

  return (
    <View style={{ alignItems: 'center', justifyContent: 'center' }} className="bg-secondary-50 flex-1">
      {data.length > 0 ? <>
        <VStack space='sm' className="w-[100%] my-2 items-center">
          <BasicButton width='95%' onPress={() => deleteAllImages()} text={i18n.t('adminModal.cleanAll', { num: data.length, size: sizeMB })} />
          {unused.length > 0 && <BasicButton width='95%' onPress={() => deleteUnusedImages()} text={i18n.t('adminModal.cleanUnused', { num: unused.length })} />}
        </VStack>
        <FlatList flex={1} contentContainerStyle={{ paddingBottom: 20 }}
          numColumns={4}
          columnWrapperStyle={{ justifyContent: 'space-around' }}
          data={data}
          renderItem={({ item, index }) => <MediaButton uri={actDir + item} unused={unused.includes(item)} usage={usage[item.replace(/\.png$/, '')]} size={75} deleteSelectedImage={deleteSelectedImage} />}
          keyExtractor={item => item.substr(item.lastIndexOf('/') + 1)}
          decelerationRate={0}
          snapToInterval={150}
          snapToAlignment='start'
        />
      </> :
        <VStack space='sm' className="w-[100%] items-center">
          <BasicButton width='95%' onPress={takePhoto} text={i18n.t('adminModal.camera')} />
          <BasicButton width='95%' onPress={pickImage} text={i18n.t('adminModal.photos')} />
          {FileSystem.documentDirectory && <BasicButton width='95%' onPress={showImages} text={i18n.t('adminModal.images')} />}
          {FileSystem.cacheDirectory && <BasicButton width='95%' onPress={showCache} text={i18n.t('adminModal.cache')} />}
          {FileSystem.cacheDirectory && <BasicButton width='95%' onPress={showPrint} text={i18n.t('mediaManager.printed')} />}
          {image && <Image alt="Image to be loaded" key={Date.now()} source={{ uri: image.uri }} style={{ width: 200, height: 200 }} />}
          <BasicButton width='95%' onPress={() => { MediaSelector.cleanImages() }} text={i18n.t('adminModal.clean')} />
        </VStack>}
    </View>
  );
}
